import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "./styles/fonts.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from "./components/navbar";
import Footer from "./components/footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Billy from "./pages/Billy";
import UseCases from "./pages/UseCases";
import Careers from "./pages/Careers";
import ILab from "./pages/ILab";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import ComingSoon from "./pages/ComingSoon";
import ScrollToTop from "./components/ScrollToTop";
import RevealManager from "./components/RevealManager";
import Seo from "./components/Seo";

import "./App.css";
import "./styles/theme.css";

// Shared shell: skip link, nav, focusable main landmark, footer.
function Layout({ children }) {
  return (
    <>
      <a className="ix-skip" href="#main-content">
        Skip to content
      </a>
      <Navbar />
      <div id="main-content" tabIndex={-1}>
        {children}
      </div>
      <Footer />
    </>
  );
}

function NotFound() {
  return (
    <main className="ix-page">
      <section className="ix-hero center">
        <div className="ix-shell">
          <span className="ix-eyebrow">Error 404</span>
          <h1>This page got away from us.</h1>
          <p className="ix-hero-lead">
            The page you are looking for does not exist or has moved.
          </p>
          <div style={{ marginTop: 28 }}>
            <Link to="/" className="ix-btn ix-btn--primary">
              Back to home →
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}

function App() {
  return (
    <Router>
      <Seo />
      <ScrollToTop />
      <RevealManager />
      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/about" element={<Layout><About /></Layout>} />
        <Route path="/projects" element={<Layout><Projects /></Layout>} />
        <Route path="/bill-y" element={<Layout><Billy /></Layout>} />
        <Route path="/use-cases" element={<Layout><UseCases /></Layout>} />
        <Route path="/careers" element={<Layout><Careers /></Layout>} />
        <Route path="/ilab" element={<Layout><ILab /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
        <Route path="/terms" element={<Layout><Terms /></Layout>} />
        <Route path="/atc" element={<Layout><ComingSoon name="ATC" /></Layout>} />
        <Route path="/meg-o" element={<Layout><ComingSoon name="Meg-O" /></Layout>} />
        <Route path="/nofloat" element={<Layout><ComingSoon name="NoFloat" /></Layout>} />
        <Route path="*" element={<Layout><NotFound /></Layout>} />
      </Routes>
    </Router>
  );
}

export default App;
